module.exports = __webpack_public_path__ + "media/images/common/ico-crown-68746d9c4089a129602da1b6359d0066.svg";